import { useEffect } from 'react'
import { useSetRecoilState } from 'recoil'
import eventBus from '../../../../services/eventBus'
import recoilStateUpdaters from '../../../../recoil/recoil.stateUpdaters.ts'
import parameterGroupsAtom from '@/pages/Parameters/parameterGroups.atom.ts'

const useParameterGroupsEventsSubscriptions = () => {
  const setGroupsState = useSetRecoilState(parameterGroupsAtom)

  useEffect(() => {
    const createSub = eventBus.sub('parameter.group.created', (group) => {
      recoilStateUpdaters.itemCreated(setGroupsState, group)
    })

    const updateSub = eventBus.sub('parameter.group.updated', (group) => {
      recoilStateUpdaters.itemUpdated(setGroupsState, group)
    })

    const removeSub = eventBus.sub('parameter.group.deleted', (id) => {
      recoilStateUpdaters.itemDeleted(setGroupsState, id)
    })

    return () => {
      createSub()
      updateSub()
      removeSub()
    }
  }, [])
}

export default useParameterGroupsEventsSubscriptions
